import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import { Table } from '../../../../components/Table'
import Button from '../../../../components/components-ui/Button/Button'
import Loading from '../../../../components/components-ui/Loading/Loading'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from '../../../../services/Api'

export default function Grupos() {
  const [showLoading, setShowLoading] = useState(false)
  const [loadGrupo, setLoadGrupo] = useState([])

  useEffect(() => {
    async function getGrupos() {
      setShowLoading(true)
      const response = await api.get('/grupo/index')
      setLoadGrupo(response.data)
      setShowLoading(false)
    }
    getGrupos()
  }, [])

  // Colunas da tabela
  const columns = [
    {
      column: 'Grupo',
    },
  ]

  return (
    <Container>
      <h3>Listagem de Grupos</h3>
      <Link to="/usina/grupo/novo" style={{ display: "contents" }}>
        <Button title="Novo" type="button" />
      </Link>

      <div className={styles.content}>
        <Table edit columns={columns}>
          {loadGrupo.map(({ id_grupo, descricao_grupo }) => (
            <tr key={id_grupo}>
              <td>
                <Link to={`/usina/grupo/edit/${id_grupo}`}>
                  <i className="fas fa-pencil-alt"></i>
                </Link>
              </td>
              <td> {descricao_grupo} </td>
            </tr>
          ))}
        </Table>
        <div className={styles.loading}>
          <Loading display={showLoading ? 'block' : 'none'} />
        </div>
      </div>
    </Container>
  )
}
